'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { isLighthouseClient } from '@/lib/isLighthouse';

// Taboola publisher account (from Taboola Backstage onboarding code).
const TABOOLA_PUBLISHER = 'newindianexpress-dinamanicomnew';
const LOADER_SRC = `//cdn.taboola.com/libtrc/${TABOOLA_PUBLISHER}/loader.js`;
const LOADER_SCRIPT_ID = 'tb_loader_script';
export type TaboolaPageType = 'homepage' | 'category' | 'article';

/**
 * Injects the Taboola `loader.js` once and declares the current page type
 * (`homepage` / `category` / `article`) — this is the "head code" from the
 * Taboola onboarding snippet, ported to a React effect so it only runs in the
 * browser (never during SSR).
 *
 * The script injection is idempotent: it self-guards on the `tb_loader_script`
 * element id exactly like Taboola's own snippet, so rendering this component on
 * multiple page types across a session loads the library only once.
 *
 * Gating: self-skips on Lighthouse/PageSpeed (navigator.webdriver + UA), the
 * same client-side guard IZootoInit uses, so callers can drop it into server
 * pages (BuilderPage, the article page) without threading server-side UA state.
 */
export default function TaboolaLoader(t0) {
  const $ = _c(3);
  const {
    pageType
  } = t0;
  let t1;
  let t2;
  if ($[0] !== pageType) {
    t1 = () => {
      if (isLighthouseClient()) {
        return;
      }
      const w = window as unknown as {
        _taboola?: unknown[];
        performance?: Performance;
      };
      w._taboola = w._taboola || [];
      (w._taboola as unknown[]).push({
        [pageType]: "auto"
      });
      if (!document.getElementById(LOADER_SCRIPT_ID)) {
        const e = document.createElement("script");
        const f = document.getElementsByTagName("script")[0];
        e.async = true;
        e.src = LOADER_SRC;
        e.id = LOADER_SCRIPT_ID;
        f?.parentNode?.insertBefore(e, f);
        if (w.performance && typeof w.performance.mark === "function") {
          w.performance.mark("tbl_ic");
        }
      }
    };
    t2 = [pageType];
    $[0] = pageType;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return null;
}